import _ from 'lodash';
import moment from 'moment';
import { fetchYearRawData, formatCategoryItems, countCategoryTotals } from './utils';
import TableView from './TableView.vue';

export default {
    components: {
        TableView,
        DetailDialog: () => import('@/components/ui/ahAccountingGeneralLedgerDialog.vue'),
    },
    data() {
        return {
            openDate: null,

            isLoading: false,
            isShowZeroItems: true,
            dateRange: [null, null],
            queryParams: {
                queryDate: null,
                startDate: null,
            },
            annualAccountingTaskStatus: null,
            settlementDate: null,
            closedDate: null,

            datas: {
                currentAssets: [], // 流動資產
                nonCurrentAssets: [], // 非流動資產
                currentLiabilities: [], // 流動負債
                nonCurrentLiabilities: [], // 非流動負債
                totalEquity: [], // 權益
            },
            totals: {
                currentAssets: 0,
                nonCurrentAssets: 0,
                currentLiabilities: 0,
                nonCurrentLiabilities: 0,
                totalEquity: 0,
                assets: 0,
                liabilities: 0,
                liabilitiesAndEquity: 0,
            },

            detailDialog: {
                accno: null,
                accnam: null,
                visible: false,
            },
        };
    },
    computed: {
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
        queryDateText() {
            const START_DATE = moment(+this.startDate);
            const END_DATE = moment(this.queryParams.queryDate);

            return `民國 ${START_DATE.year() - 1911} 年 ${START_DATE.format('MM 月 DD 日')} ～ 民國 ${END_DATE.year() - 1911} 年 ${END_DATE.format('MM 月 DD 日')}`;
        },
        settlementDateTxt() {
            return this.settlementDate ? moment(this.settlementDate).format('YYYY年MM月DD日') : null;
        },
        closedDateTxt() {
            return this.annualAccountingTaskStatus === 2 && this.closedDate ? moment(this.closedDate).format('YYYY年MM月DD日') : null;
        },
        startDate() {
            if (!this.queryParams.startDate) {
                return moment(this.queryParams.queryDate)
                    .startOf('year')
                    .format('x');
            }
            return moment(this.queryParams.startDate).format('x');
        },
        isAssetsAndLiabilitiesEqual() {
            return this.totals.liabilitiesAndEquity === this.totals.assets;
        },
    },
    methods: {
        async updateData() {
            this.isLoading = true;

            // 取得資料、開始、結束日期
            const { startDate, queryDate, rawData } = await fetchYearRawData(this.dateRange[0]);

            // 阻擋查詢日期在開帳日期之前
            if (startDate) {
                const OPEN_DATE = moment(+startDate);
                const SELECTED_DATE = moment(+queryDate);
                if (SELECTED_DATE.isBefore(OPEN_DATE)) {
                    this.$message({
                        showClose: true,
                        message: `${SELECTED_DATE.year()}年開帳日期為 ${OPEN_DATE.format('YYYY-MM-DD')}，請重新選擇日期範圍。`,
                        type: 'error',
                    });
                    return;
                }
            }

            this.queryParams.startDate = startDate;
            this.queryParams.queryDate = queryDate;

            // 轉換為資產負債表的分類
            const items = formatCategoryItems(rawData, this.isShowZeroItems);
            this.datas.currentAssets = items.currentAssets;
            this.datas.nonCurrentAssets = items.nonCurrentAssets;
            this.datas.currentLiabilities = items.currentLiabilities;
            this.datas.nonCurrentLiabilities = items.nonCurrentLiabilities;
            this.datas.totalEquity = items.totalEquity;

            // 計算每個分類需要的統計
            const totals = countCategoryTotals(items);
            this.totals.currentAssets = totals.currentAssets;
            this.totals.nonCurrentAssets = totals.nonCurrentAssets;
            this.totals.currentLiabilities = totals.currentLiabilities;
            this.totals.nonCurrentLiabilities = totals.nonCurrentLiabilities;
            this.totals.totalEquity = totals.totalEquity;
            this.totals.assets = totals.assets;
            this.totals.liabilities = totals.liabilities;
            this.totals.liabilitiesAndEquity = totals.liabilitiesAndEquity;

            this.annualAccountingTaskStatus = rawData.annualAccountingTaskStatus;
            this.settlementDate = rawData.lastSettlementBelongDate;
            this.closedDate = rawData.lastClosedOperationTime;

            this.isLoading = false;
        },
        updateQuery() {
            this.queryParams.startDate = this.openDate;
            this.queryParams.queryDate = Number(
                moment(Number(this.queryParams.queryDate))
                    .endOf('day')
                    .format('x'),
            );
        },
        // 找出指定年份的開帳傳票，去定義開始日期
        async getYearlyOpenVoucher(year) {
            const resp = await this.$api({
                url: 'AccountingSummaryPage/QueryVouchers',
                method: 'GET',
                params: {
                    StartDateStart: moment(`${year}/01/01`, 'YYYY-MM-DD')
                        .startOf('year')
                        .format('x'),
                    StartDateEnd: moment(`${year}/12/31`, 'YYYY-MM-DD')
                        .endOf('year')
                        .format('x'),
                    TransactionType: 12,
                },
            });
            if (resp.data.totalNum) {
                return _.head(resp.data.items)?.dat;
            }
            return null;
        },

        onClickItem(item) {
            this.detailDialog.accno = item.accno;
            this.detailDialog.accnam = item.accnam;
            this.detailDialog.visible = true;
        },
    },
};
